import { SignupFormData } from 'modules/auth/hooks/useSignupForm'
import { EnumAuthTrackingEvents } from 'modules/auth/lib/tracking/events'
import { Message } from 'modules/common/components/_ui/Message/Message'
import { useTrackDirtyField } from 'modules/common/hooks/useTrackDirtyField'
import { useTrackOnMount } from 'modules/common/hooks/useTrackOnMount'
import { useTranslation } from 'modules/common/hooks/useTranslation'
import { useFormContext } from 'react-hook-form'
import { SignupFormActions } from '../SignupFormActions'
import { SignupFormCaptcha } from '../SignupFormCaptcha'
import { SignupFormPasswordField } from './SignupFormPasswordField/SignupFormPasswordField'

export const SignupFormPassword = () => {
  const { t } = useTranslation(['auth-components', 'common'])

  const {
    formState: { errors, isSubmitting },
    watch,
  } = useFormContext<SignupFormData>()

  useTrackDirtyField<SignupFormData>({
    name: 'password',
    event: EnumAuthTrackingEvents.SIGNUP_PASSWORD_FORM_STARTED,
  })
  useTrackOnMount({
    eventType: EnumAuthTrackingEvents.SIGNUP_PASSWORD_FORM_ENTER,
  })

  const { password, userAcceptsTerms, captchaToken } = watch()

  return (
    <div className="flex flex-col gap-6 lg:w-124">
      <h2 className="md:text-3xl">{t('signupForm.password.title')}</h2>
      <Message content={t('signupForm.password.notification')} withIcon />
      <SignupFormPasswordField autoFocus />
      <SignupFormCaptcha />
      <SignupFormActions
        event={EnumAuthTrackingEvents.SIGNUP_PASSWORD_FORM_VALIDATED}
        isNextButtonDisabled={
          !password ||
          !!errors.password ||
          !userAcceptsTerms ||
          !!errors.userAcceptsTerms ||
          !captchaToken ||
          !!errors.captchaToken
        }
        isNextButtonLoading={isSubmitting}
        nextButtonLabel={t('common:confirm')}
      />
    </div>
  )
}
